export default "__VITE_ASSET__BI4ne9eN__"